import type { QueryFunctionContext } from '@tanstack/react-query';
import { JobsAdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.backupMixdownStatus>>;

export const createFetchBackupMixdownStatusQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ mixdownId }], signal }: TParams) =>
    call(() => cancelOnSignal(JobsAdminService.adminGetMixdownJobBackupFilesStatus({ mixdownId }), signal));
